module.exports = __webpack_public_path__ + "img/prophecies.ecfb48d1.svg";